import customer1 from './customer1-img.png';
import customer2 from './customer2-img.png';
import customer3 from './customer3-img.png';
import customer4 from './customer4-img.png';
import customer5 from './customer5-img.png';
import customer6 from './customer6-img.png';

const customerImages = [customer1, customer2, customer3, customer4, customer5, customer6];

export default customerImages;
